import axios from 'axios';
import API_URL from '../config';
import config from "../config";

const getAuthToken = () => localStorage.getItem('token');
const getRefreshToken = () => localStorage.getItem('refreshToken');

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Ajouter le token JWT aux en-têtes de chaque requête si l'utilisateur est authentifié
api.interceptors.request.use(config => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Appliquer API_URL uniquement si la méthode est `get` ou `post` et que l'URL n'est pas complète
    if ((config.method === 'get' || config.method === 'post') && !config.url.startsWith(API_URL)) {
        config.url = `${API_URL}${config.url}`;
        console.log(config.url);
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// Intercepter les réponses pour gérer les tokens expirés
api.interceptors.response.use(response => {
    return response;
}, async error => {
    const originalRequest = error.config;

    // Vérifier si l'erreur est due à un token expiré
    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = getRefreshToken();
        console.log('refreshToken', refreshToken);

        if (refreshToken) {
            try {
                const response = await axios.post(`${API_URL}/users/token/refresh/`, { refresh: refreshToken });
                const newToken = response.data.access;
                localStorage.setItem('token', newToken);
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                // Gérer l'erreur de rafraîchissement du token
                console.log(refreshError);
                localStorage.clear();
                return Promise.reject(refreshError);
            }
        }
    }

    return Promise.reject(error);
});

export default api;
